import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { PartnerModuleActiveDialog } from '../partnerModuleActiveDialog/PartnerModuleActiveDialog'
import { PartnerModuleInactiveDialog } from '../partnerModuleInactiveDialog/PartnerModuleInactiveDialog'

import { PartnerScopes } from '@percent/admin-dashboard/constants/scopes'
import { ReactComponent as HorizontalIcon } from '@percent/admin-dashboard/common/assets/images/horizontal_icon.svg'
import styles from './PartnerModuleMenu.module.scss'

type TableMenuProps = {
  refresh: () => void
  moduleName: PartnerScopes
  partnerId: string
  moduleTitle: string
  isModuleActive: boolean
}

export function TableMenu({ refresh, moduleName, partnerId, moduleTitle, isModuleActive }: TableMenuProps) {
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = useState(null)

  const [open, setOpen] = useState<'active' | 'inactive' | null>(null)

  const handleOpenMenu = (event: any) => setAnchorEl(event.currentTarget)

  const handleCloseMenu = () => setAnchorEl(null)

  const handleChangePartnerStatus = () => {
    handleCloseMenu()

    if (isModuleActive) setOpen('inactive')
    else setOpen('active')
  }

  const handleClosePartnerStatus = () => {
    handleCloseMenu()
    setOpen(null)
  }

  return (
    <div>
      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleOpenMenu} className={styles.menu}>
        <HorizontalIcon />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        style={{
          display: 'flex',
          alignItems: 'flex-start'
        }}
        data-testid="menu-option"
      >
        <MenuItem onClick={handleChangePartnerStatus}>{t('menu.changeStatus')}</MenuItem>
      </Menu>
      <PartnerModuleInactiveDialog
        onClose={handleClosePartnerStatus}
        openInactiveModal={open === 'inactive'}
        id={partnerId}
        scope={moduleName}
        refresh={refresh}
        moduleTitle={moduleTitle}
      />
      <PartnerModuleActiveDialog
        onClose={handleClosePartnerStatus}
        openActiveModal={open === 'active'}
        partnerId={partnerId}
        scope={moduleName}
        moduleTitle={moduleTitle}
        refresh={refresh}
      />
    </div>
  )
}
